import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'fileWrapper';

export class FileWrapper extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
